// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DashboardPage_wrapper__19Ns0","select":"DashboardPage_select__1OlnW"};